import soundcoreLogo from 'shared/assets/logos/soundcore.svg'
import soundscapeLogo from 'shared/assets/logos/soundscape.svg'
import settingsSlidersIcon from 'shared/assets/icons/settings-sliders.svg'

import { HomePageCmsContent } from 'core/services/cms/interfaces'

import homeHeroBackground from '../assets/home-hero-bg.jpg'
import gpuIcon from '../assets/gpu.svg'
import speedIcon from '../assets/speed.svg'
import lightningIcon from '../assets/lightning.png'
import parallelIcon from '../assets/parallel.svg'
import waveIcon from '../assets/wave.svg'
import soundcoreDesktopBackground from '../sections/home-product/assets/product-feature-display-soundcore-desktop-bg.jpeg'
import soundcoreMobileBackground from '../sections/home-product/assets/product-feature-display-soundcore-mobile-bg.jpg'
import soundscapeDesktopBackground from '../sections/home-product/assets/product-feature-display-soundscape-desktop-bg.jpeg'
import soundscapeMobileBackground from '../sections/home-product/assets/product-feature-display-soundscape-mobile-bg.jpeg'
import pluginsIcon from '../sections/home-product/assets/plugins.svg'
import databaseIcon from '../sections/home-product/assets/database.svg'
import cloudBrainIcon from '../sections/home-product/assets/cloud-brain.svg'
import speakerIcon from '../sections/home-product/assets/speaker.svg'
import multizoneIcon from '../sections/home-product/assets/multizone.svg'

// Storybook/development fixture only. Runtime page should use CMS payload.
export const defaultHomePageCmsContent: HomePageCmsContent = {
  hero: {
    pillText: 'Blazing fast',
    titleText: 'Accelerated Audio Computing',
    description: 'Using the power of GPUs to enhance audio in real-time',
    backgroundImageUrl: homeHeroBackground,
  },
  soundcore: {
    logoUrl: soundcoreLogo,
    text: 'Build complex tools with greater speed, novel creativity, and GPU-powered scalability',
    buttonText: 'Explore Soundcore',
    buttonUrl: '/soundcore',
    desktopBackgroundUrl: soundcoreDesktopBackground,
    mobileBackgroundUrl: soundcoreMobileBackground,
    featureCards: [
      {
        iconUrl: pluginsIcon,
        text: 'Accelerate Plugin Development',
      },
      {
        iconUrl: databaseIcon,
        text: 'Increase Instance Count',
      },
      {
        iconUrl: cloudBrainIcon,
        text: 'Run Edge-to-Cloud Neural Models',
      },
    ],
  },
  acceleration: {
    title: 'A Technological First: GPU Acceleration For Audio',
    cards: [
      {
        title: 'Tap into powerful GPU resources',
        iconUrl: gpuIcon,
      },
      {
        title: 'Overcome long-standing CPU and DSP limitations',
        iconUrl: speedIcon,
      },
      {
        statPrefix: 'Up to',
        statValue: '75X',
        statSuffix: 'Faster',
        body: 'Compared to conventional processors',
        iconUrl: lightningIcon,
      },
      {
        title: 'Unlock massive parallel processing capacity',
        iconUrl: parallelIcon,
      },
      {
        title: 'Futurize how audio is created, processed, and delivered',
        iconUrl: waveIcon,
      },
    ],
  },
  soundscape: {
    logoUrl: soundscapeLogo,
    text: 'Transform existing vehicle GPUs into powerful audio processors using a fraction of GPU capacity ' +
      'to deliver differentiating, system-wide features',
    buttonText: 'Explore Soundscape',
    buttonUrl: '/soundscape',
    desktopBackgroundUrl: soundscapeDesktopBackground,
    mobileBackgroundUrl: soundscapeMobileBackground,
    featureCards: [
      {
        iconUrl: speakerIcon,
        text: 'Enable Real-Time Acoustic Tuning',
      },
      {
        iconUrl: multizoneIcon,
        text: 'Differentiate with True Multizone Playback',
      },
      {
        iconUrl: settingsSlidersIcon,
        text: 'Unlock Advanced Audio Features',
      },
    ],
  },
  partnerProgram: {
    title: 'Be Blazing Fast',
    subtitle: 'Collaborate to Accelerated Audio Computing',
    pillItems: [
      'Chip makers and architects',
      'Plugin makers',
      'Algorithm developers',
      'Infrastructure cloud tool developers',
    ],
    buttonText: 'Learn more',
    buttonUrl: '/resources',
  },
  technologyBenefits: {
    title: 'Technology Benefits',
    description: 'Serving Pro Audio Automotive OEMs and Tier 1 suppliers through SDKs, platform middleware, ' +
      'and customizable modules',
    cards: [
      {
        title: 'GPU\nCapacity',
        body: 'Turn deployed GPUs into massively parallel audio processors',
      },
      {
        title: '5X\nFaster',
        body: 'Development compared to conventional approaches',
      },
      {
        title: 'Up to\n75X',
        body: 'Acceleration for offline rendering, 10x for embedded integrations',
      },
    ],
  },
  bottomHero: {
    titleLine1: 'Complete Knowledge Hub',
    titleLine2: 'for Developers',
    description:
      'Access explainers, documentation, guides, examples, and support for end-to-end development and deployment',
    buttonText: 'Learn more',
    buttonUrl: '/resources',
  },
}

export const resolveHomePageCmsContent = (
  cmsContent: HomePageCmsContent | null,
): HomePageCmsContent => {
  if (!cmsContent) {
    throw new Error('Home CMS content missing')
  }

  return cmsContent
}
